import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { getAllDetails, getSpecificDetailsById, postAllData } from '../../service/ProductService';
import { USERLIST, CREATE_USER, UPDATE_USER_MENU, USER_DATA_BY_ID } from '../../config/ApiConstant';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { Checkbox } from 'primereact/checkbox';
import { PermissionTab } from './permissionTab';
import { Dropdown } from 'primereact/dropdown';
import Loader from '../../components/Loadeer/Loader';
import { useLocation } from 'react-router-dom';

export const UserWiseMenu = () => {
    document.title = 'User Wise Menu | Royal Seeds';

    //Loading
    const toast = useRef<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [pageLoader, setPageLoader] = useState<boolean>(false);

    //Userlist/Role
    const [userList, setUserList] = useState<any>([]);
    const [editId, setEditId] = useState<any>();
    const [roleData, setRoleData] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [selectedRolesValue, setSelectedRolesValue] = useState<any>([]);
    const [selectedRolesActions, setSelectedRolesActions] = useState<any>([]);
    const [allCheck, setAllCheck] = useState<any>([]);

    const location: any = useLocation();

    // use effect method
    useEffect(() => {
        if (location.state) {
            const state: any = location.state;
            if (state != null) {
                getDataByUserId(state?.id);
                setEditId(state?.id);
            }
        }
        getUserList();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        const updatedAllCheckedMenus = selectedRolesActions.filter((action: any) => Object.keys(action).every((key) => key === 'menu' || action[key] === 1)).map((action: any) => action.menu);

        setAllCheck(updatedAllCheckedMenus);
    }, [selectedRolesActions]);

    //get data by user id
    const getDataByUserId = async (id: any) => {
        setEditId(id);
        setPageLoader(true);

        const response = await getSpecificDetailsById(USER_DATA_BY_ID, id.code);
        if (response) {
            const actions = response?.assigned_actions && !window.cn(response?.assigned_actions) ? JSON.parse(response?.assigned_actions) : [];

            setRoleData({
                role: response.role
            });

            setSelectedRolesValue(response?.assigned_menu?.split(','));
            const parsedActions = Object.keys(actions).map((menu) => ({
                menu,
                ...actions[menu] // Spread the properties of the object
            }));

            setSelectedRolesActions(parsedActions);
            setPageLoader(false);
        }
    };

    // Get Users Data from API
    const getUserList = async () => {
        setPageLoader(true);
        const response = await getAllDetails(USERLIST);
        // get response
        if (response) {
            const DataList = response;

            if (DataList.length === 0) {
                setUserList([]);
                setPageLoader(false);
            } else {
                if (response) {
                    setPageLoader(false);
                    let array: any = [];
                    for (let i = 0; i < DataList.length; i++) {
                        let userObj: any = {};
                        userObj['name'] = DataList[i].full_name;
                        userObj['code'] = DataList[i].id;
                        array.push(userObj);
                    }
                    setUserList(array);
                    if (location?.state === null) {
                        setEditId(array[0]);
                        getDataByUserId(array[0]);
                    }
                }
            }
        } else {
            toast.current?.show({
                severity: 'error',
                summary: 'Alert',
                detail: 'Something went wrong, Please try again.'
            });
        }
    };

    const onCheckboxxChange = (e: any, val: any) => {
        let updatedSelectedRoles = selectedRolesValue ? [...selectedRolesValue] : [];

        if (e.checked) {
            updatedSelectedRoles.push(e.value); // Add the selected menu
        } else {
            // Remove the menu if unchecked
            updatedSelectedRoles = updatedSelectedRoles.filter((menu) => menu !== e.value);
        }

        // Update selected roles value
        setSelectedRolesValue(updatedSelectedRoles);

        // Sync selected roles actions
        setSelectedRolesActions((prev: any) => {
            const updatedActions = [...prev];

            // If a menu is selected, add its default actions
            if (e.checked) {
                if (!prev.some((action: any) => action.menu === e.value)) {
                    updatedActions.push({
                        menu: e.value,
                        ...val
                    });
                }
            } else {
                // Remove the menu's actions if unchecked
                return updatedActions.filter((action) => action.menu !== e.value);
            }

            return updatedActions;
        });
    };

    const onActionCheckboxChange = (menu: any, field: string, isChecked: boolean) => {
        setSelectedRolesActions((prev: any) => prev.map((row: any) => (row.menu === menu ? { ...row, [field]: isChecked ? 1 : 0 } : row)));
        renderCheckboxxTemplate(field, menu);
    };

    const onAllCheckboxChange = (menu: any, e: any) => {
        let updatedAllCheckdRoles = allCheck ? [...allCheck] : [];

        if (e.checked) {
            updatedAllCheckdRoles.push(e.value); // Add the selected menu
        } else {
            // Remove the menu if unchecked
            updatedAllCheckdRoles = updatedAllCheckdRoles.filter((menu) => menu !== e.value);
        }

        // Update selected roles value
        setAllCheck(updatedAllCheckdRoles);

        setSelectedRolesActions((prev: any) => prev.map((row: any) => (row.menu === menu ? Object.keys(row).reduce((acc, key) => ({ ...acc, [key]: key === 'menu' ? row[key] : e.checked ? 1 : 0 }), {}) : row)));
    };

    const renderCheckboxxTemplate = (field: string, menu: string) => {
        const actionRow = selectedRolesActions.find((action: any) => action.menu === menu);

        return (
            <div className="form col-12 md:col-3 role-items">
                <div className="field-checkbox mb-0">
                    <Checkbox inputId={`${menu}-${field}`} checked={actionRow && actionRow[field] === 1} onChange={(e) => onActionCheckboxChange(menu, field, e.checked)} />
                    <label htmlFor={`${menu}-${field}`} className="role-checkbox">
                        {field}
                    </label>
                </div>
            </div>
        );
    };

    // on submit
    const onSubmit = async () => {
        try {
            setLoading(true);

            //Request object
            let formRequestData = new FormData();

            if (!window.cn(selectedRolesValue) && selectedRolesValue.length > 0) {
                formRequestData.append('assigned_menu', selectedRolesValue);
            }
            if (!window.cn(selectedRolesActions) && selectedRolesActions.length > 0) {
                formRequestData.append('assigned_actions', JSON.stringify(selectedRolesActions));
            }
            formRequestData.append('id', editId.code);

            const response = await postAllData(UPDATE_USER_MENU, formRequestData);

            if (response) {
                setErrors(false);
                setLoading(false);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response.message
                });
                getDataByUserId(editId);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (error: any) {
            if (error.response) {
                setLoading(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Alert',
                    detail: error.response.data.error
                });
            }
        }
    };

    return (
        <>
            <PermissionTab mainTabLabel="UserWise Menu Management" />
            <Toast ref={toast} />

            <div className="grid crud-demo main-div-sec role-management mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="field col-12 mb-4">
                            <b>Select User</b>
                            <Dropdown className="ml-4" filter value={editId} onChange={(e) => getDataByUserId(e.value)} options={userList} optionLabel="name" name="crop" placeholder="Select User"></Dropdown>
                        </div>
                        <hr />

                        <>
                            <label>
                                <b>Assign Menu for this User *</b>
                                <small className="p-invalid-txt">{errors['action']}</small>
                            </label>{' '}
                            <br />
                            <br />
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Permission</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="rolewise"
                                            name="option"
                                            value="RoleWise Menu Management"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('RoleWise Menu Management') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="rolewise">RoleWise Menu Management</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="userwise"
                                            name="option"
                                            value="UserWise Menu Management"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('UserWise Menu Management') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="userwise">UserWise Menu Management</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Main</b>
                                    </label>
                                </div>
                                {/* <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="college_management"
                                            name="option"
                                            value="College Management"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('College Management') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="college_management">College Management</label>
                                    </div>
                                </div> */}
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="user_management"
                                            name="option"
                                            value="User Management"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('User Management') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="user_management">User Management</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox inputId="billing" name="option" value="Billing" checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Billing') !== -1 : ''} onChange={(e: any) => onCheckboxxChange(e, null)} />
                                        <label htmlFor="billing">Billing</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"> </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox inputId="dashboard" name="option" value="Dashboard" checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Dashboard') !== -1 : ''} onChange={(e: any) => onCheckboxxChange(e, null)} />
                                        <label htmlFor="dashboard">Dashboard</label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            {/* College Mmanagement Start */}
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>College Managements</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="college_management"
                                            name="option"
                                            value="College Management"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('College Management') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="college_management">College Management</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="pci_approval"
                                            name="option"
                                            value="PCI Approval"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('PCI Approval') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="pci_approval">PCI Approval</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="admitted_list"
                                            name="option"
                                            value="Admitted List"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Admitted List') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="admitted_list">Admitted List</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"></div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="passout_list"
                                            name="option"
                                            value="Passout List"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Passout List') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="passout_list">Passout List</label>
                                    </div>
                                </div>
                            </div>
                            {/* College Mmanagement End */}
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Refresher Course</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="online_refresher_course"
                                            name="option"
                                            value="Online Refresher Course"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Online Refresher Course') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="online_refresher_course">Online Refresher Course</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="offline_refresher_course"
                                            name="option"
                                            value="Offline Refresher Course"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Offline Refresher Course') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="offline_refresher_course">Offline Refresher Course</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Applications</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="fresh_application"
                                            name="option"
                                            value="Fresh Application"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Fresh Application') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Fresh Registration': 0,
                                                    'Fresh Registration Other': 0,
                                                    'Fresh Registration (Transfer To Gujarat)': 0,
                                                    'Transfer DD/DNH': 0,
                                                    'Eligible Application (Maharashtra State)': 0,
                                                    'Eligible Application (Other)': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="fresh_application">Fresh Application</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="renew_reEntry_app"
                                            name="option"
                                            value="Renew/Re-Entry Application"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Renew/Re-Entry Application') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, { 'Renew Application': 0, 'Re-Entry Application': 0 })}
                                        />
                                        <label htmlFor="renew_reEntry_app">Renew/Re-Entry Application</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="election_app"
                                            name="option"
                                            value="Election Application"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Election Application') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Electoral Roll Fees Application': 0,
                                                    'Election Deposit Application': 0,
                                                    'Nomination Form Fees': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="election_app">Election Application</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"></div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="other_app"
                                            name="option"
                                            value="Other Application"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Other Application') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Address Change': 0,
                                                    'Name Change': 0,
                                                    'Good Standing Application': 0,
                                                    'Duplicate Cert.': 0,
                                                    'Reg Cancel': 0,
                                                    'Degree Additional': 0,
                                                    'Pro To Org': 0,
                                                    Penalty: 0,
                                                    'Penalty Under Jan Vishwas': 0,
                                                    Search: 0
                                                })
                                            }
                                        />
                                        <label htmlFor="other_app">Other Application</label>
                                    </div>
                                </div>
                            </div>
                            {!window.cn(selectedRolesValue) &&
                                (selectedRolesValue.includes('Fresh Application') ||
                                    selectedRolesValue.includes('Renew/Re-Entry Application') ||
                                    selectedRolesValue.includes('Election Application') ||
                                    selectedRolesValue.includes('Other Application')) && (
                                    <div className="col-12 md:col-12 role-table">
                                        {selectedRolesValue.map((item: any) =>
                                            item === 'Fresh Application' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Fresh Application </div>

                                                        <div className="form grid col-12 md:col-10 action-r">
                                                            {renderCheckboxxTemplate('Fresh Registration', 'Fresh Application')}
                                                            {renderCheckboxxTemplate('Fresh Registration Other', 'Fresh Application')}
                                                            {renderCheckboxxTemplate('Fresh Registration (Transfer To Gujarat)', 'Fresh Application')}
                                                            {renderCheckboxxTemplate('Transfer DD/DNH', 'Fresh Application')}
                                                            {renderCheckboxxTemplate('Eligible Application (Maharashtra State)', 'Fresh Application')}
                                                            {renderCheckboxxTemplate('Eligible Application (Other)', 'Fresh Application')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0">
                                                                    <Checkbox
                                                                        inputId="check-all-fresh-application"
                                                                        value="Fresh Application"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Fresh Application') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Fresh Application', e)}
                                                                    />

                                                                    <label htmlFor="check-all-fresh-application">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Renew/Re-Entry Application' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Renew/Re-Entry Application </div>
                                                        <div className="form grid col-12 md:col-10 action-r">
                                                            {renderCheckboxxTemplate('Renew Application', 'Renew/Re-Entry Application')}
                                                            {renderCheckboxxTemplate('Re-Entry Application', 'Renew/Re-Entry Application')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0">
                                                                    <Checkbox
                                                                        inputId="check-all-renew-re-entry-application"
                                                                        value="Renew/Re-Entry Application"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Renew/Re-Entry Application') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Renew/Re-Entry Application', e)}
                                                                    />

                                                                    <label htmlFor="check-all-fresh-application">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Election Application' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Election Application </div>
                                                        <div className="form grid col-12 md:col-10 action-r">
                                                            {renderCheckboxxTemplate('Electoral Roll Fees Application', 'Election Application')}
                                                            {renderCheckboxxTemplate('Election Deposit Application', 'Election Application')}
                                                            {renderCheckboxxTemplate('Nomination Form Fees', 'Election Application')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0 ">
                                                                    <Checkbox
                                                                        inputId="check-all-organizer"
                                                                        value="Election Application"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Election Application') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Election Application', e)}
                                                                    />
                                                                    <label htmlFor="check-all-organizer">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Other Application' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Other Application </div>

                                                        <div className="form grid col-12 md:col-10 p-0 m-0">
                                                            {renderCheckboxxTemplate('Address Change', 'Other Application')}
                                                            {renderCheckboxxTemplate('Name Change', 'Other Application')}
                                                            {renderCheckboxxTemplate('Good Standing Application', 'Other Application')}
                                                            {renderCheckboxxTemplate('Duplicate Cert.', 'Other Application')}
                                                            {renderCheckboxxTemplate('Reg Cancel', 'Other Application')}
                                                            {renderCheckboxxTemplate('Degree Additional', 'Other Application')}
                                                            {renderCheckboxxTemplate('Pro To Org', 'Other Application')}
                                                            {renderCheckboxxTemplate('Penalty', 'Other Application')}
                                                            {renderCheckboxxTemplate('Penalty Under Jan Vishwas', 'Other Application')}
                                                            {renderCheckboxxTemplate('Search', 'Other Application')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0  ">
                                                                    <Checkbox
                                                                        inputId="check-all-employee"
                                                                        value="Other Application"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Other Application') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Other Application', e)}
                                                                    />
                                                                    <label htmlFor="check-all-employee">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Farmer' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Farmer </div>

                                                        <div className="form grid col-12 md:col-10 action-r">
                                                            {renderCheckboxxTemplate('add', 'Farmer')}
                                                            {renderCheckboxxTemplate('edit', 'Farmer')}
                                                            {renderCheckboxxTemplate('delete', 'Farmer')}
                                                            <div className="form col-12 md:col-2 role-items">
                                                                <div className="field-checkbox mb-0 ">
                                                                    <Checkbox inputId="check-all-farmer" value="Farmer" checked={!window.cn(allCheck) ? allCheck.indexOf('Farmer') !== -1 : ''} onChange={(e) => onAllCheckboxChange('Farmer', e)} />
                                                                    <label htmlFor="check-all-farmer">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                ''
                                            )
                                        )}
                                    </div>
                                )}
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Book Appointment</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="appointment_slots"
                                            name="option"
                                            value="Appointment Slots"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Appointment Slots') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="appointment_slots">Appointment Slots</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="appointment_list"
                                            name="option"
                                            value="Appointment List"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Appointment List') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="appointment_list">Appointment List</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Account</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="bank-entry"
                                            name="option"
                                            value="Bank Entry"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Bank Entry') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="bank-entry">Bank Entry</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="cash-entry"
                                            name="option"
                                            value="Cash Entry"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Cash Entry') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="cash-entry">Cash Entry</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox inputId="jv_entry" name="option" value="JV Entry" checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('JV Entry') !== -1 : ''} onChange={(e: any) => onCheckboxxChange(e, null)} />
                                        <label htmlFor="jv_entry">JV Entry</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"></div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="account_master"
                                            name="option"
                                            value="Account Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Account Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="account_master">Account Master</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="account_group"
                                            name="option"
                                            value="Account Group"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Account Group') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="account_group">Account Group</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Certicates</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="provisional_certi"
                                            name="option"
                                            value="Provisional Certificate"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Provisional Certificate') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="provisional_certi">Provisional Certificate</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="original_certi"
                                            name="option"
                                            value="Original Certificate"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Original Certificate') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="original_certi">Original Certificate</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="duplicate_entry"
                                            name="option"
                                            value="Duplicate Certificate"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Duplicate Certificate') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="duplicate_entry">Duplicate Certificate</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"></div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="additional_certi"
                                            name="option"
                                            value="Additional Certificate"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Additional Certificate') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="additional_certi">Additional Certificate</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="good_standing_certi"
                                            name="option"
                                            value="Good Standing Certificate"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Good Standing Certificate') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="good_standing_certi">Good Standing Certificate</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="reg_date_update"
                                            name="option"
                                            value="Registration Date Update"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Registration Date Update') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="reg_date_update">Registration Date Update</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Master</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="app_bill_master"
                                            name="option"
                                            value="Application Bill Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Application Bill Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="app_bill_master">Application Bill Master</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="app_master"
                                            name="option"
                                            value="Application Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Application Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="app_master">Application Master</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="approval_master"
                                            name="option"
                                            value="Approval Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Approval Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="approval_master">Approval Master</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"></div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="board-master"
                                            name="option"
                                            value="Board Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Board Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="board-master">Board Master</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="college-entry"
                                            name="option"
                                            value="College Entry"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('College Entry') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="college-entry">College Entry</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="council_master"
                                            name="option"
                                            value="Council Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Council Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="council_master">Council Master</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"></div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="document_master"
                                            name="option"
                                            value="Document Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Document Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="document_master">Document Master</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="exam-authority"
                                            name="option"
                                            value="Exam Authority"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Exam Authority') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="exam-authority">Exam Authority</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="hospital_master"
                                            name="option"
                                            value="Hospital Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Hospital Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="hospital_master">Hospital Master</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"></div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="other_master"
                                            name="option"
                                            value="Other Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Other Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="other_master">Other Master</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="university-master"
                                            name="option"
                                            value="University Master"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('University Master') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="university-master">University Master</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-4">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="user-bind"
                                            name="option"
                                            value="User Bind / Email Update / Password Update"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('User Bind / Email Update / Password Update') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="user-bind">User Bind / Email Update / Password Update</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>In-Out Register</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="in-out"
                                            name="option"
                                            value="InWard Register"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('InWard Register') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="in-out">InWard Register</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="outward"
                                            name="option"
                                            value="OutWard Register"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('OutWard Register') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="outward">OutWard Register</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Job Portal</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="department_list"
                                            name="option"
                                            value="Department List"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Department List') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="department_list">Department List</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="student_list"
                                            name="option"
                                            value="Student List"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Student List') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="student_list">Student List</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox inputId="job-list" name="option" value="Job List" checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Job List') !== -1 : ''} onChange={(e: any) => onCheckboxxChange(e, null)} />
                                        <label htmlFor="job-list">Job List</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Letters</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="verification_letter"
                                            name="option"
                                            value="Verification Letters"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Verification Letters') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'RHUS Verification Letters': 0,
                                                    'NIOS Verification Letters': 0,
                                                    'University Verification Letters': 0,
                                                    'Board Verification Letters': 0,
                                                    'College Verification Letters': 0,
                                                    'School Verification Letters': 0,
                                                    'Gujarat Other Councils': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="verification_letter">Verification Letters</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="cancellation_letter"
                                            name="option"
                                            value="Cancellation Letters"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Cancellation Letters') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Registration Cancellation': 0,
                                                    'Application Cancellation': 0,
                                                    'Submission Letter': 0,
                                                    'Wrong Affidavit Letter': 0,
                                                    'False&Fake': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="cancellation_letter">Cancellation Letters</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="reminder_letter"
                                            name="option"
                                            value="Reminder Letters"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Reminder Letters') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Reminder To College': 0,
                                                    'Reminder To School': 0,
                                                    'Reminder To Council': 0,
                                                    'Reminder To Hospital': 0,
                                                    'Reminder To Medical': 0,
                                                    'Reminder To University': 0,
                                                    'Reminder To Board': 0,
                                                    'Reminder To NIOS': 0,
                                                    'Reminder To RHUS': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="reminder_letter">Reminder Letters</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"> </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="other_letter"
                                            name="option"
                                            value="Other Letters"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Other Letters') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'NOC Letter': 0,
                                                    'Transfer In': 0,
                                                    'Letters To Hospital': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="other_letter">Other Letters</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="data_flow"
                                            name="option"
                                            value="Data Flow"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Data Flow') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Data Flow Letter': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="data_flow">Data Flow</label>
                                    </div>
                                </div>
                            </div>
                            {!window.cn(selectedRolesValue) &&
                                (selectedRolesValue.includes('Other Letters') ||
                                    selectedRolesValue.includes('Data Flow') ||
                                    selectedRolesValue.includes('Verification Letters') ||
                                    selectedRolesValue.includes('Cancellation Letters') ||
                                    selectedRolesValue.includes('Reminder Letters')) && (
                                    <div className="col-12 md:col-12 role-table">
                                        {selectedRolesValue.map((item: any) =>
                                            item === 'Verification Letters' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Verification Letters </div>

                                                        <div className="form grid col-12 md:col-10 action-r">
                                                            {renderCheckboxxTemplate('RHUS Verification Letters', 'Verification Letters')}
                                                            {renderCheckboxxTemplate('NIOS Verification Letters', 'Verification Letters')}
                                                            {renderCheckboxxTemplate('University Verification Letters', 'Verification Letters')}
                                                            {renderCheckboxxTemplate('Board Verification Letters', 'Verification Letters')}
                                                            {renderCheckboxxTemplate('College Verification Letters', 'Verification Letters')}
                                                            {renderCheckboxxTemplate('School Verification Letters', 'Verification Letters')}
                                                            {renderCheckboxxTemplate('Gujarat Other Councils', 'Verification Letters')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0">
                                                                    <Checkbox
                                                                        inputId="check-all-verification-letters"
                                                                        value="Verification Letters"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Verification Letters') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Verification Letters', e)}
                                                                    />

                                                                    <label htmlFor="check-all-verification-letters">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Cancellation Letters' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Cancellation Letters </div>
                                                        <div className="form grid col-12 md:col-10 action-r">
                                                            {renderCheckboxxTemplate('Registration Cancellation', 'Cancellation Letters')}
                                                            {renderCheckboxxTemplate('Application Cancellation', 'Cancellation Letters')}
                                                            {renderCheckboxxTemplate('Warning Letter', 'Cancellation Letters')}
                                                            {renderCheckboxxTemplate('Submission Letter', 'Cancellation Letters')}
                                                            {renderCheckboxxTemplate('Wrong Affidavit Letter', 'Cancellation Letters')}
                                                            {renderCheckboxxTemplate('False&Fake', 'Cancellation Letters')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0">
                                                                    <Checkbox
                                                                        inputId="check-all-cancellation-letters"
                                                                        value="Cancellation Letters"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Cancellation Letters') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Cancellation Letters', e)}
                                                                    />

                                                                    <label htmlFor="check-all-cancellation-letters">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Reminder Letters' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Reminder Letters </div>
                                                        <div className="form grid col-12 md:col-10 action-r">
                                                            {renderCheckboxxTemplate('Reminder To College', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To School', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To Council', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To Hospital', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To Medical', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To University', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To Board', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To NIOS', 'Reminder Letters')}
                                                            {renderCheckboxxTemplate('Reminder To RHUS', 'Reminder Letters')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0 ">
                                                                    <Checkbox
                                                                        inputId="check-all-reminder-letters"
                                                                        value="Reminder Letters"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Reminder Letters') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Reminder Letters', e)}
                                                                    />
                                                                    <label htmlFor="check-all-reminder-letters">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Other Letters' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row">
                                                        <div className="col-12 md:col-2 left-menu">Other Letters </div>

                                                        <div className="form grid col-12 md:col-10 p-0 m-0">
                                                            {renderCheckboxxTemplate('NOC Letter', 'Other Letters')}
                                                            {renderCheckboxxTemplate('Transfer In', 'Other Letters')}
                                                            {renderCheckboxxTemplate('Letters To Hospital', 'Other Letters')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0  ">
                                                                    <Checkbox
                                                                        inputId="check-all-other-letters"
                                                                        value="Other Letters"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Other Letters') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Other Letters', e)}
                                                                    />
                                                                    <label htmlFor="check-all-other-letters">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : item === 'Data Flow' ? (
                                                <>
                                                    <div className="form flex col-12 md:col-12 inner-row" key={item}>
                                                        <div className="col-12 md:col-2 left-menu">Data Flow</div>
                                                        <div className="form grid col-12 md:col-10 p-0 m-0">
                                                            {renderCheckboxxTemplate('Data Flow Letter', 'Data Flow')}
                                                            <div className="form col-12 md:col-3 role-items">
                                                                <div className="field-checkbox mb-0">
                                                                    <Checkbox
                                                                        inputId="check-all-data-flow"
                                                                        value="Data Flow"
                                                                        checked={!window.cn(allCheck) ? allCheck.indexOf('Data Flow') !== -1 : ''}
                                                                        onChange={(e) => onAllCheckboxChange('Data Flow', e)}
                                                                    />
                                                                    <label htmlFor="check-all-data-flow">Check All</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                ''
                                            )
                                        )}
                                    </div>
                                )}
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Scrutiny</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="scr_guj"
                                            name="option"
                                            value="Scrutiny (Gujarat)"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Scrutiny (Gujarat)') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="scr_guj">Scrutiny (Gujarat)</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="scru_oth_state"
                                            name="option"
                                            value="Scrutiny (Other State)"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Scrutiny (Other State)') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="scru_oth_state">Scrutiny (Other State)</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="scru_transfer_guj"
                                            name="option"
                                            value="Scrutiny (Transfer To Gujarat)"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Scrutiny (Transfer To Gujarat)') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="scru_transfer_guj">Scrutiny (Transfer To Gujarat)</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form grid">
                                <div className="col-12 md:col-2"> </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="scru_dd"
                                            name="option"
                                            value="Scrutiny (Transfer DD/DNH)"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Scrutiny (Transfer DD/DNH)') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="scru_dd">Scrutiny (Transfer DD/DNH)</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="scru_deg"
                                            name="option"
                                            value="Scrutiny (Degree Additional)"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Scrutiny (Degree Additional)') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="scru_deg">Scrutiny (Degree Additional)</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="scru_re_entry"
                                            name="option"
                                            value="Scrutiny (Re Entry)"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Scrutiny (Re Entry)') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="scru_re_entry">Scrutiny (Re Entry)</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Report</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="reports"
                                            name="option"
                                            value="Reports"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Reports') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Application Register': 0,
                                                    'Fee Register': 0,
                                                    'Fresh Application Register': 0,
                                                    'Degree Details': 0,
                                                    'G Number-Wise Details': 0,
                                                    'Receipt Download': 0,
                                                    'Registration Validation': 0,
                                                    'Application Details': 0,
                                                    'Statistics Reports': 0,
                                                    'Registration Cancellation': 0,
                                                    'In Out Register Report': 0,
                                                    'DD Register Reports': 0,
                                                    'Prov-Org Certificate Registration': 0,
                                                    'College Wise Registration': 0,
                                                    'Government Report': 0,
                                                    'PCI Register': 0,
                                                    'Record Register': 0,
                                                    'Electrol Register': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="reports">Reports</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="finacial_report"
                                            name="option"
                                            value="Financial Reports"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Financial Reports') !== -1 : ''}
                                            onChange={(e: any) =>
                                                onCheckboxxChange(e, {
                                                    'Account Ledger': 0,
                                                    'Cash Book Detail': 0,
                                                    'Bank Book Detail': 0,
                                                    'JV Book Detail': 0,
                                                    'Trial Balance': 0,
                                                    ' Profit Loss Accoun': 0
                                                })
                                            }
                                        />
                                        <label htmlFor="finacial_report">Financial Reports</label>
                                    </div>
                                </div>
                            </div>
                            {!window.cn(selectedRolesValue) && (selectedRolesValue.includes('Reports') || selectedRolesValue.includes('Financial Reports')) && (
                                <div className="col-12 md:col-12 role-table">
                                    {selectedRolesValue.map((item: any) =>
                                        item === 'Reports' ? (
                                            <>
                                                <div className="form flex col-12 md:col-12 inner-row">
                                                    <div className="col-12 md:col-2 left-menu">Reports </div>
                                                    <div className="form grid col-12 md:col-10 action-r">
                                                        {renderCheckboxxTemplate('Application Register', 'Reports')}
                                                        {renderCheckboxxTemplate('Fee Register', 'Reports')}
                                                        {renderCheckboxxTemplate('Fresh Application Register', 'Reports')}
                                                        {renderCheckboxxTemplate('Degree Details', 'Reports')}
                                                        {renderCheckboxxTemplate('G Number-Wise Details', 'Reports')}
                                                        {renderCheckboxxTemplate('Receipt Download', 'Reports')}
                                                        {renderCheckboxxTemplate('Registration Validation', 'Reports')}
                                                        {renderCheckboxxTemplate('Application Details', 'Reports')}
                                                        {renderCheckboxxTemplate('Statistics Reports', 'Reports')}
                                                        {renderCheckboxxTemplate('Registration Cancellation', 'Reports')}
                                                        {renderCheckboxxTemplate('In Out Register Report', 'Reports')}
                                                        {renderCheckboxxTemplate('DD Register Reports', 'Reports')}
                                                        {renderCheckboxxTemplate('Prov-Org Certificate Registration', 'Reports')}
                                                        {renderCheckboxxTemplate('College Wise Registration', 'Reports')}
                                                        {renderCheckboxxTemplate('Government Report', 'Reports')}
                                                        {renderCheckboxxTemplate('PCI Register', 'Reports')}
                                                        {renderCheckboxxTemplate('Record Register', 'Reports')}
                                                        {renderCheckboxxTemplate('Electrol Register', 'Reports')}

                                                        <div className="form col-12 md:col-3 role-items">
                                                            <div className="field-checkbox mb-0 ">
                                                                <Checkbox inputId="check-all-reports" value="Reports" checked={!window.cn(allCheck) ? allCheck.indexOf('Reports') !== -1 : ''} onChange={(e) => onAllCheckboxChange('Reports', e)} />
                                                                <label htmlFor="check-all-reports">Check All</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : item === 'Financial Reports' ? (
                                            <>
                                                <div className="form flex col-12 md:col-12 inner-row">
                                                    <div className="col-12 md:col-2 left-menu">Financial Reports </div>

                                                    <div className="form grid col-12 md:col-10 p-0 m-0">
                                                        {renderCheckboxxTemplate('Account Ledger', 'Financial Reports')}
                                                        {renderCheckboxxTemplate('Cash Book Detail', 'Financial Reports')}
                                                        {renderCheckboxxTemplate('Bank Book Detail', 'Financial Reports')}
                                                        {renderCheckboxxTemplate('JV Book Detail', 'Financial Reports')}
                                                        {renderCheckboxxTemplate('Trial Balance', 'Financial Reports')}
                                                        {renderCheckboxxTemplate('Profit Loss Account', 'Financial Reports')}
                                                        <div className="form col-12 md:col-3 role-items">
                                                            <div className="field-checkbox mb-0  ">
                                                                <Checkbox
                                                                    inputId="check-all-financial-reports"
                                                                    value="Financial Reports"
                                                                    checked={!window.cn(allCheck) ? allCheck.indexOf('Financial Reports') !== -1 : ''}
                                                                    onChange={(e) => onAllCheckboxChange('Financial Reports', e)}
                                                                />
                                                                <label htmlFor="check-all-financial-reports">Check All</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            ''
                                        )
                                    )}
                                </div>
                            )}
                            <hr></hr>
                            <div className="form grid">
                                <div className="col-12 md:col-2">
                                    <label>
                                        <b>Front Website</b>
                                    </label>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="banner_img"
                                            name="option"
                                            value="Banner Image"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Banner Image') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="banner_img">Banner Image</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="announcement_notification"
                                            name="option"
                                            value="Announcement & Notifications"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Announcement & Notifications') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="announcement_notification">Announcement & Notifications</label>
                                    </div>
                                </div>
                                <div className="col-12 md:col-3">
                                    <div className="field-checkbox">
                                        <Checkbox
                                            inputId="circular_notice"
                                            name="option"
                                            value="Circular/Notice"
                                            checked={!window.cn(selectedRolesValue) ? selectedRolesValue.indexOf('Circular/Notice') !== -1 : ''}
                                            onChange={(e: any) => onCheckboxxChange(e, null)}
                                        />
                                        <label htmlFor="circular_notice">Circular/Notice</label>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="p-fluid formgrid grid mt-3">
                                <div className="field col-12 md:col-12">
                                    <div style={{ float: 'right' }}>
                                        <Button label="Save" icon="pi pi-check" onClick={onSubmit} loading={loading} disabled={!window.cn(selectedRolesValue) ? false : true} />
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>

            {pageLoader === true && <Loader />}
        </>
    );
};
